
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([background-color='blue']) outline-styled-text-baseline{
  --grid-dark-theme-text-color:var(--brand-gray-100);
  --quote-text-color:var(--grid-dark-theme-text-color);
  --quote-icon-border-color:var(--grid-dark-theme-text-color);
  --link-background-color-default:var(--grid-dark-theme-text-color);
  --list-marker-color:var(--grid-dark-theme-text-color);
  --quote-icon-background-color:transparent;
  --workday-body-color:var(--brand-gray-100);

  --heading-color:var(--brand-gray-100);
  --body-color:var(--brand-gray-100);
}
:host([background-color='blue']) outline-heading-baseline{
  --heading-color:var(--brand-gray-100);
}
:host([background-color='green'])  outline-heading-baseline[ruled]::after{
  border-color:var(--brand-green-100);
}
:host([has-border-bottom='true']){
  border-bottom:2px solid var(--brand-gray-400);
}
.background-color-blue{
  color:var(--grid-dark-theme-text-color);
}
outline-column-baseline > .block,
outline-column-baseline > div{
  width:100%;
  margin-bottom:var(--spacing-7);
}
outline-column-baseline > .block:last-child, outline-column-baseline > div:last-child{
    margin-bottom:0;
  }
outline-column-baseline .full-height{
  height:100%;
}
:host([equal-heights='true']) .height-grow{
  height:100%;
  display:flex;
}
:host([equal-heights='true']) .height-grow > *{
  flex-grow:1;
}
:host([background-svg='true']){
  background-image:url('data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiBpY29uLWJyYW5kLXEiIGZvY3VzYWJsZT0iZmFsc2UiIHZpZXdCb3g9IjAgMCAzOSAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBjbGFzcz0ic3ZnLWNzcC0xMjgiIGQ9Ik0xOC42MzMgMjkuMTMzYy03LjU2Ny0zLjg2Ny0xMS42MzMtMy41MzMtMTYuMy0wLjczMyAzLjczMy00LjgzMyAxMS4xLTUuNDMzIDE4LjctMS40IDYuOCAzLjUgMTQuMDMzIDMgMTcuNjMzIDEuMS02LjQzMyA3LjEtMTYuOTMzIDIuNjY3LTIwLjAzMyAxLjAzM3oiIGZpbGw9IiMwMGEzZTAiPiAgIDwvcGF0aD4gICA8cGF0aCBjbGFzcz0ic3ZnLWNzcC0xMjkiIGQ9Ik0yMS4wNjcgMTEuODMzYzAtNC45MzMtMy43MzMtOS4xLTkuMDY3LTkuMXMtOS4wNjcgNC4xNjctOS4wNjcgOS4xYzAgNS4xMzMgNC4xNjcgOS4xIDkuMDY3IDkuMXM5LjA2Ny0zLjk2NyA5LjA2Ny05LjF6TTI0IDExLjgzM2MwIDYuNzMzLTUuMzY3IDExLjgzMy0xMiAxMS44MzNzLTEyLTUuMS0xMi0xMS44MzNjMC02LjUgNS40MzMtMTEuODMzIDEyLTExLjgzM3MxMiA1LjMzMyAxMiAxMS44MzN2MHoiIGZpbGw9IiMwMGEzZTAiPjwvcGF0aD4KPC9zdmc+Cg==');
  background-size:290%;
  background-repeat:no-repeat;
  background-position:-24% 86%;
}
@media (min-width: 1024px){
:host([background-svg='true']){
    background-position:-53% 86%;
    background-size:200%
}
  }
`;